/*
 *  Osano Cookie Policy
 *  CSS & Javascript Implementation Included
 *
 */


export function scrollanimation(elemname) {

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    if (isIE11) {
      return;
    }
  
    let y;
    let ey;
    let attr;
    let wh;
    let setElem = document.querySelectorAll(elemname);
  
    setElem.forEach(function (elem, index) {
      elem.classList.add("anipending");
    });
  
    window.addEventListener(
      "scroll",
      function (e) {
        actionScroll(e);
      },
      { passive: true }
    );

    actionScroll();

    function actionScroll(e) {
      attr = setElem;
  
        attr.forEach(function (elem, index) {
          y = window.scrollY + window.innerHeight;
          ey = elem.offsetTop;
  
          let aniClassName = elem.dataset.animation;
  
          if (y > ey) {
            if (!elem.classList.contains("animate__animated")) {
              elem.classList.add("animate__animated");
              elem.classList.add(aniClassName);
              // console.log("triggered");
            }
          } else {
            if (elem.classList.contains("animate__animated")) {
              elem.classList.remove("animate__animated");
              elem.classList.remove(aniClassName);
            }
          }
        });
    }
}
